export function isTouchDeviceByContext({is_mobile, is_tablet}) {
    return is_mobile || is_tablet;
}

export function isTouchDevice() {
    return (
        !!(typeof window !== 'undefined' && ('ontouchstart' in window || (window.DocumentTouch && typeof document !== 'undefined' && document instanceof window.DocumentTouch))) ||
        !!(typeof navigator !== 'undefined' && (navigator.maxTouchPoints || navigator.msMaxTouchPoints))
    );
}
